// extracted by mini-css-extract-plugin
module.exports = {"breakpointVerySmall":"640px","breakpointSmall":"768px","breakpointMedium":"1024px","breakpointLarge":"1200px"};